import {SHOW_SCHEDULE, HIDE_SCHEDULE ,
        SET_LIVE_RESENTATION_SHOW, SET_LIVE_RESENTATION_HIDE,
        SET_PANEL_DISCUSSION_SHOW, SET_PANEL_DISCUSSION_HIDE,
        SET_ON_DEMAND_SHOW,SET_ON_DEMAND_HIDE,
        SET_ROUND_TABLES_SHOW, SET_ROUND_TABLES_HIDE,
        SET_BOOTH_HIDE,SET_BOOTH_SHOW } from "../../ActionTypes/Schedule/scheduleTypes";

const initialState = {
  isScheduleVisible         : false,
  isLivePresentationVisible : false,
  isPanelDiscussionVisible  : false,
  isOnDemandVisible         : false,
  isRoundTableVisible       : false,
  isBoothVisible            : false

};

const scheduleReducer = (state = initialState, action: { type: string }) => {
  switch (action.type) {
    case SHOW_SCHEDULE:
      return { ...state, isScheduleVisible: true };
    case HIDE_SCHEDULE:
      return { ...state, isScheduleVisible: false };
    case SET_LIVE_RESENTATION_SHOW:
      return { ...state, isLivePresentationVisible: true };
    case SET_LIVE_RESENTATION_HIDE:
      return { ...state, isLivePresentationVisible: false };
    case SET_PANEL_DISCUSSION_SHOW:
      return { ...state,isPanelDiscussionVisible:true}
    case SET_PANEL_DISCUSSION_HIDE:
        return { ...state,isPanelDiscussionVisible:false}

  
    
    case SET_ON_DEMAND_SHOW:
      return { ...state,isOnDemandVisible:true}
    case SET_ON_DEMAND_HIDE:
        return { ...state,isOnDemandVisible:false}
    
    case SET_ROUND_TABLES_SHOW:
      return {...state,isRoundTableVisible:true}
    case SET_ROUND_TABLES_HIDE:
      return {...state,isRoundTableVisible:false}
    
    case SET_BOOTH_SHOW:
      return {...state,isBoothVisible:true}
    case SET_BOOTH_HIDE:
      return {...state,isBoothVisible:false}  

    default:
      return state;
  }
};

export default scheduleReducer;
